function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M21.188 19.125H2.813a.188.188 0 00-.188.188v1.875c0 .103.084.187.188.187h18.375a.188.188 0 00.187-.188v-1.875a.188.188 0 00-.188-.187zM5.945 17.25h1.992a.229.229 0 00.218-.16l1.259-3.89h5.137l1.247 3.89a.23.23 0 00.218.16h2.088a.229.229 0 00.216-.302L13.444 2.78a.232.232 0 00-.216-.155h-2.397a.224.224 0 00-.216.155L5.73 16.948a.201.201 0 00-.011.075c-.003.124.1.227.227.227zm5.998-12.096h.096l1.964 6.183H9.959l1.985-6.183z"
})));